var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowBordered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.13567 0C1.4122 0 0 1.4122 0 3.13567V9V14.8643C0 16.5878 1.4122 18 3.13567 18H9H14.8643C16.5878 18 18 16.5878 18 14.8643V9V3.13567C18 1.4122 16.5878 0 14.8643 0H9H3.13567ZM3.13567 1.38462H9H14.8643C15.8395 1.38462 16.6154 2.16052 16.6154 3.13567V9V14.8643C16.6154 15.8395 15.8395 16.6154 14.8643 16.6154H9H3.13567C2.16052 16.6154 1.38462 15.8395 1.38462 14.8643V9V3.13567C1.38462 2.16052 2.16052 1.38462 3.13567 1.38462ZM8.99865 4.84615C8.85119 4.84615 8.70449 4.90167 8.59165 5.01382L2.24594 11.2892C2.01956 11.5142 2.0189 11.8789 2.24459 12.1032L3.13161 12.9862C3.35523 13.2091 3.71652 13.2104 3.94291 12.9902L8.99865 8.06025L14.0557 12.9902C14.2814 13.2097 14.6434 13.2084 14.867 12.9862L15.7541 12.1032C15.9797 11.8775 15.9798 11.5135 15.7527 11.2892L9.407 5.01382C9.29485 4.90167 9.14611 4.84615 8.99865 4.84615Z",
    fill: "#735BF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowBordered);
export default __webpack_public_path__ + "static/media/UpArrowBordered.37060760a5383253efea199bdfde8bd4.svg";
export { ForwardRef as ReactComponent };